import OrderProduct from './OrderProduct'

export default OrderProduct
